// @flow

import React, { useEffect } from 'react';
import type { Node } from 'react';
import { Location } from '@reach/router';
import styled, { ThemeProvider } from 'styled-components';

import LoadFonts from 'fonts/load-fonts/WebsiteOld';
import { Metadata } from 'components/Gui';
import type { PageMetaData } from 'components/Gui/Metadata';
import type { PageConfig, FooterLegal, FooterConfig, HeaderConfig } from 'contexts/page-context';
import { useSetPageState } from 'contexts/page-context';
import { maxWidthContainer, Width } from 'styles';
import { paramsToObj } from 'utils';
import { NAV_HIDING_QUERY_KEY, NAV_HIDING_QUERY_MAP } from '../WebsiteDefault';
import { IS_BROWSER } from 'Constants';

const Wrapper = styled.div`
  ${maxWidthContainer(Width.XL, 0, 0)};
`;

const WebsiteOldPage = ({
  metaData,
  page,
  headerConfig = {},
  footerLegal = {},
  footerConfig = {},
  children,
  ...rest
}: {
  metaData: PageMetaData,
  page: PageConfig,
  headerConfig?: HeaderConfig,
  footerLegal?: FooterLegal,
  footerConfig?: FooterConfig,
  children: Node,
}) => {
  const setPageState = useSetPageState();
  const { [NAV_HIDING_QUERY_KEY]: navHiddenValue } = IS_BROWSER ? paramsToObj(window.document.location.search) : {};
  const navHidden = navHiddenValue ? NAV_HIDING_QUERY_MAP[navHiddenValue] || false : false;
  useEffect(() => {
    setPageState({
      page,
      headerConfig: navHidden
        ? {
            toggleHidden: {
              nav: true,
              ctaButton: true,
            },
          }
        : headerConfig,
      footerLegal,
      footerConfig,
    });
  }, [setPageState, page, headerConfig, footerConfig, footerLegal, navHidden]);
  return (
    <>
      <Location>{props => <Metadata data={metaData} {...props} />}</Location>
      <LoadFonts />
      <ThemeProvider theme={{ mode: 'figure' }}>
        <Wrapper {...rest}>{children}</Wrapper>
      </ThemeProvider>
    </>
  );
};

export default WebsiteOldPage;
